import { Activity } from 'apollo/types';
import {
  LocalizedEntranceTicketTypeBackOffice,
  LocalizedText,
} from 'apollo/localizedTypes';
import { Options } from 'components/UI/Form/types';

type NameId = {
  name: string | LocalizedText | null;
  id: string;
};

const resolveName = (name: NameId['name']): string => {
  if (!name) return '';
  return typeof name === 'string' ? name : name.es || '';
};

const mapOptions = (
  objects: Activity[] | LocalizedEntranceTicketTypeBackOffice[] | undefined
): Options | undefined => {
  const typedObjects = objects as NameId[];
  const labelValue = typedObjects?.map((obj) => {
    return { label: resolveName(obj.name), value: Number(obj.id) };
  });
  return labelValue;
};

export default mapOptions;
